import React, { createContext, useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Notification from './Notification';
const AppContext = createContext();


export const AppProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [username, setUsername] = useState('');
  const [notification, setNotification] = useState(null);

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(null), 3000); // Automatically hide notification after 3 seconds
  };

  const handleCloseNotification = () => {
    setNotification(null);
  };

  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      const token = localStorage.getItem('token');
      const storedUsername = localStorage.getItem('username');
      setUsername(storedUsername);

      try {
        const response = await axios.get('https://my-first-website-production.up.railway.app/checkSession', {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        });

        if (response.data.loggedIn) {
          setLoggedIn(true); 
          showNotification( `logged in successfully hello ${storedUsername}`)
        } else {
          showNotification(`${response.data.message}`)
          setLoggedIn(false);
          if (window.location.pathname.includes('cards')) {
            navigate('/');
          }    }
      } catch (error) {
        console.error('Error checking session:', error);
        showNotification(`error please try Again`)
        setLoggedIn(false);
        if (window.location.pathname.includes('cards')) {
          navigate('/');
        } }
    };

    checkSession();
  }, [navigate]);

  return (
    <AppContext.Provider
      value={{
        loggedIn,
        setLoggedIn,
        scrolled,
        setScrolled,
        username,
        setUsername,
        showNotification,
        notification,
        handleCloseNotification
      }}
    >
      {children}
      <Notification message={notification} onClose={handleCloseNotification} />
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
